import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeProvider";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Brands from "@/pages/Brands";
import About from "@/pages/About";
import DealerNetwork from "@/pages/DealerNetwork";
import Support from "@/pages/Support";
import News from "@/pages/News";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ContentProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Layout><Home /></Layout>} />
                <Route path="/products" element={<Layout><Products /></Layout>} />
                <Route path="/brands" element={<Layout><Brands /></Layout>} />
                <Route path="/about" element={<Layout><About /></Layout>} />
                <Route path="/dealer-network" element={<Layout><DealerNetwork /></Layout>} />
                <Route path="/support" element={<Layout><Support /></Layout>} />
                <Route path="/news" element={<Layout><News /></Layout>} />
                <Route path="/admin" element={<Layout><Admin /></Layout>} />
                <Route path="/login" element={<Layout><Admin /></Layout>} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </div>
        </ContentProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
